(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tb-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tb-menu-panel')) {
    customElements.define('tb-menu-panel', class extends HTMLElement {
      connectedCallback() { this.addEventListener('keyup', this.closeAccordion); }
      disconnectedCallback() { this.removeEventListener('keyup', this.closeAccordion); }
      closeAccordion(event) {
        if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
        const accordion = event.target.closest('[data-tb-menu-accordion]');
        if (!accordion || !this.contains(accordion)) return;
        event.stopPropagation();
        accordion.open = false;
        accordion.querySelector('summary')?.focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tb-recipe"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tb-recipe')) {
  customElements.define('tb-recipe', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.controller?.abort();
        this.controller = new AbortController();
        this.querySelectorAll('[data-recipe-print],[data-recipe-share],[data-recipe-reset]').forEach(button => { button.hidden = false; });
        this.addEventListener('click', async event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-recipe-print')) this.querySelector('.tb-recipe__print-dialog')?.showModal();
          if (button.hasAttribute('data-recipe-print-close')) this.querySelector('.tb-recipe__print-dialog')?.close();
          if (button.hasAttribute('data-recipe-print-confirm')) await this.printRecipe(button);
          if (button.hasAttribute('data-recipe-reset')) this.querySelectorAll('.tb-recipe__ingredient input').forEach(input => { input.checked = false; });
          if (button.hasAttribute('data-recipe-share')) {
            if (navigator.share) {
              try { await navigator.share({title: this.dataset.title, url: this.dataset.url}); return; }
              catch (error) { if (error.name === 'AbortError') return; }
            }
            const panel = this.querySelector('.tb-recipe__share');
            panel.hidden = !panel.hidden;
            button.setAttribute('aria-expanded', String(!panel.hidden));
            if (!panel.hidden) { const input = panel.querySelector('input'); input.focus(); input.select(); }
          }
          if (button.hasAttribute('data-recipe-copy')) {
            const status = this.querySelector('[data-recipe-status]');
            try { await navigator.clipboard.writeText(this.dataset.url); status.textContent = this.dataset.copied; }
            catch { const input = this.querySelector('.tb-recipe__share input'); input.focus(); input.select(); status.textContent = this.dataset.copyHelp; }
          }
        }, {signal: this.controller.signal});
      });
    }
    async printRecipe(button) {
      if (this.printing) return;
      this.printing = true;
      button.disabled = true;
      const dialog = this.querySelector('.tb-recipe__print-dialog');
      const status = dialog.querySelector('[data-recipe-print-status]');
      status.textContent = dialog.dataset.preparing;
      try {
        const withPhoto = dialog.querySelector('[data-recipe-print-photo]')?.checked === true;
        this.printFrame?.remove();
        const frame = document.createElement('iframe');
        this.printFrame = frame;
        frame.dataset.recipePrintFrame = '';
        frame.title = this.dataset.title;
        frame.setAttribute('aria-hidden', 'true');
        frame.tabIndex = -1;
        frame.style.cssText = 'position:fixed;inset:0 auto auto 0;width:1px;height:1px;border:0;opacity:0;pointer-events:none';
        frame.src = 'about:blank';
        await new Promise(resolve => {
          frame.addEventListener('load', resolve, { once: true });
          document.body.append(frame);
        });
        const printDocument = frame.contentDocument;
        const printWindow = frame.contentWindow;
        if (!printDocument || !printWindow || !this.isConnected) throw new Error('Print document unavailable');
        printDocument.documentElement.lang = document.documentElement.lang;
        printDocument.title = this.dataset.title;
        const charset = printDocument.createElement('meta');
        charset.setAttribute('charset', 'utf-8');
        const style = printDocument.createElement('style');
        style.textContent = `
          @page{margin:15mm}*{box-sizing:border-box}body{margin:0;background:#fff;color:#182a53;font:10pt/1.45 Arial,sans-serif;overflow-wrap:anywhere}
          h1{font-size:23pt;line-height:1.1;margin:0 0 10pt}h2{font-size:15pt;line-height:1.2;margin:0 0 9pt;break-after:avoid}h3{font-size:11pt;margin:0 0 4pt;break-after:avoid}p{margin:0 0 9pt}
          .tb-recipe__hero{display:block;margin-bottom:14pt}.tb-recipe__hero::after{content:'';display:block;clear:both}.tb-recipe__eyebrow{font-size:8pt;letter-spacing:.08em;text-transform:uppercase;color:#555}.tb-recipe__photo{float:right;width:42%;max-width:200pt;margin:0 0 12pt 18pt}.tb-recipe__photo img{display:block;width:100%;height:auto;max-height:150pt;object-fit:contain}img{max-width:100%;height:auto}
          .tb-recipe__facts{display:flex;flex-wrap:wrap;gap:18pt;margin:0 0 14pt;padding:8pt 0;border-block:1px solid #bbb}.tb-recipe__facts dt{font-size:8pt;text-transform:uppercase;color:#555}.tb-recipe__facts dd{font-size:10pt;font-weight:700;margin:3pt 0 0}
          .tb-recipe__card{display:block}.tb-recipe__ingredients{margin:0 0 15pt}.tb-recipe__list{columns:2;column-gap:24pt;list-style:none;padding:0;margin:0}.tb-recipe__ingredient{padding:3pt 0;break-inside:avoid}.tb-recipe__ingredient-group{padding-top:6pt;break-after:avoid}.tb-recipe__ingredient label{display:block}.tb-recipe__ingredient span{text-decoration:none}
          .tb-recipe__steps{list-style:none;margin:0;padding:0}.tb-recipe__steps>li{display:grid;grid-template-columns:20pt minmax(0,1fr);gap:8pt;margin:0 0 10pt;break-inside:avoid}.tb-recipe__step-number{display:grid;place-items:center;border:1px solid #182a53;border-radius:50%;height:18pt;width:18pt;font-size:9pt;font-weight:700}.tb-recipe__steps p{margin:0}
          .tb-recipe__notes{border-top:1px solid #bbb;margin-top:14pt;padding-top:10pt}.tb-recipe__notes h2{font-size:13pt}.tb-recipe__print-source{display:block;border-top:1px solid #bbb;padding-top:8pt;margin-top:14pt;font-size:8pt;color:#555}a{color:inherit;text-decoration:none}
        `;
        const source = this.querySelector(':scope > article');
        const recipe = source.cloneNode(true);
        const originalImages = [...source.querySelectorAll('img')];
        recipe.querySelectorAll('img').forEach((image, index) => {
          image.src = originalImages[index].currentSrc || originalImages[index].src;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.loading = 'eager';
        });
        recipe.querySelectorAll('.tb-recipe__actions,.tb-recipe__share,.tb-recipe__hint,.tb-recipe__reset,button,input,script,iframe,video,audio,dialog').forEach(element => element.remove());
        if (!withPhoto) recipe.querySelectorAll('.tb-recipe__photo,img,picture').forEach(element => element.remove());
        printDocument.head.append(charset, style);
        printDocument.body.append(recipe);
        await Promise.race([
          Promise.allSettled([...printDocument.images].map(image => image.decode())),
          new Promise(resolve => { this.printTimeout = setTimeout(resolve, 8000); })
        ]);
        clearTimeout(this.printTimeout);
        if (!frame.isConnected || !this.isConnected) return;
        status.textContent = '';
        dialog.close();
        printWindow.addEventListener('afterprint', () => this.querySelector('[data-recipe-print]')?.focus(), { once: true });
        printWindow.focus();
        printWindow.print();
      } catch {
        status.textContent = dialog.dataset.error;
      } finally {
        this.printing = false;
        button.disabled = false;
      }
    }
    disconnectedCallback() { clearTimeout(this.printTimeout); this.printFrame?.remove(); cancelAnimationFrame(this.frame); this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tb-tag-filters"] && !Shopify.designMode) return;
  try {
    // Shopify's tag links change the path. Retain native facets, sorting and preview.
  const prepareClassificationLinks = () => {
    document.querySelectorAll('[data-tbr-tag-links] a').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.href);
      const current = new URLSearchParams(window.location.search);
      for (const name of new Set(current.keys())) {
        if (name.startsWith('filter.') || name === 'sort_by' || name === 'preview_theme_id') {
          url.searchParams.delete(name);
          current.getAll(name).forEach((value) => url.searchParams.append(name, value));
        }
      }
      url.searchParams.delete('page');
      link.href = url.pathname + url.search;
    });
  };
  prepareClassificationLinks();
  document.addEventListener('shopify:section:load', prepareClassificationLinks);
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-tbr-tag-links] a')) prepareClassificationLinks();
    document.querySelectorAll('.tbr-tag-filter[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.tbr-tag-filter[open]').forEach((details) => { details.removeAttribute('open'); details.querySelector('summary')?.focus(); });
  });
  } catch(e) { console.error(e); }
})();

})();
